import { Bus } from "./bus";

export class BusWithOverlaps extends Bus {
  public willCauseOverlaps: boolean;
}
